export const pages = {
    home: "/",
    exercise: "/exercise",
    ai_exercise: "/ai-exercise",
    ai_exercise_session: "/ai-exercise-session",
    summary: "/summary",
    simple_summary: "/simple-summary",
    profile: "/profile",
    exercise_list: "/exercises",
    exercise_edit: "/exercises/:id",
    session: "/session",
    imprint: "/imprint",
    setting: "/setting",
    login: "/login",
};
